// extracted by mini-css-extract-plugin
export default {"affair":"Affair_affair__41ViV","name":"Affair_name__lcDyS","closeButton":"Affair_closeButton__ksof2"};